import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.63 3.238a1.03 1.03 0 0 0-1.048-.162L2.638 7.897A1.029 1.029 0 0 0 2.69 9.82l2.577.895 1.397 4.617c.002.01.01.015.015.024a.33.33 0 0 0 .213.195c.006.003.01.009.018.01h.006a.3.3 0 0 0 .155-.007l.017-.003a.3.3 0 0 0 .127-.082q.007-.004.015-.01l2.008-2.216 2.931 2.27c.178.139.398.214.624.214.489 0 .911-.342 1.012-.82l2.174-10.679a1.02 1.02 0 0 0-.349-.99M7.392 11.59l-.471 2.292-.983-3.252 4.876-2.54-3.331 3.332a.33.33 0 0 0-.09.168m5.76 3.182a.36.36 0 0 1-.232.266.35.35 0 0 1-.343-.052l-3.175-2.46a.333.333 0 0 0-.45.04l-1.398 1.541.47-2.285 4.793-4.793a.333.333 0 0 0-.39-.531L5.52 10.097 2.908 9.19a.35.35 0 0 1-.241-.328.35.35 0 0 1 .223-.345l11.942-4.822a.36.36 0 0 1 .372.058.35.35 0 0 1 .121.345z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }